import styles from "./InputCard.module.scss";
import { useTranslation } from "react-i18next";
import {
  TextField,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  Autocomplete,
  MenuItem,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { useCallback, useEffect, useState } from "react";
import PaymentMethod from "./PaymentMethod";
import { constant } from "../misc/constant";
import _ from "lodash";
import { useAws } from "../aws";
import axios from "axios";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const gender = [];

const InputCard = (props) => {
  const { t } = useTranslation();
  const { hookForm, paymentItmeProps, price } = props;
  const { control, getValues, setValue, trigger } = hookForm || {};
  const [allValue, setAllValue] = useState({
    birth_day: null,
    birth_month: null,
    birth_year: null,
    child_gender: "",
    child_name: "",
    child_surname: "",
    email: "",
    emergency_name: "",
    emergency_number: null,
    emergency_surname: "",
    parent_name: "",
    parent_surname: "",
    prefix: "",
    type: "",
  });

  const [options, setOptions] = useState(["null"]);

  const { x_api_key, x_api_key_cms, apiStage } = useAws();
  const { awsHttp, uploadToS3 } = useAws();
  const isValidConfrimEmail = useCallback((confirmEmail) => {
    const email = getValues("email");
    return email === confirmEmail
      ? true
      : t("Email Confrimation does not match email");
  }, []);

  const isValidYearOfBirth = useCallback((year) => {
    const minYear = 1900;
    const maxYear = new Date().getFullYear();
    return (year >= minYear && year <= maxYear) || !year
      ? true
      : t("Invalid Year of Birth");
  }, []);
  const isValidDayOfBirth = useCallback((day) => {
    const minDay = 1;
    const maxDay = 31;
    return (day >= minDay && day <= maxDay) || !day
      ? true
      : t("Invalid Day of Birth");
  }, []);

  return (
    <div className={`card-view ${styles.card} ${props.xc || ""}`}>
      <div className="container">
        <h1 className="mb-1">{t("Fill in the Child information")}</h1>
        <div className="input-container mt-4">
          <div className="input-div full-width">
            <Controller
              key="phoneNumber"
              name="phoneNumber"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  type={"number"}
                  sx={{ width: "100%" }}
                  label={t("Phone")}
                  variant="standard"
                  {...field}
                  error={!!error}
                  helperText={error ? error.message : null}
                  onChange={(e) => {
                    setValue("phoneNumber", e.target.value);
                  }}
                />
              )}
              rules={{
                required: t("Required"),
                pattern: {
                  value: /^[0-9]*$/,
                  message: t("Invalid Phone no."),
                },
                minLength: {
                  value: 8,
                  message: t("Invalid Phone no."),
                },
              }}
            />
          </div>
          <div className="input-div">
            <Controller
              key="IDname"
              name="IDname"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Kids First Name")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              rules={{
                required: t("Required"),
                pattern: {
                  value: /^[a-zA-Z\s]*$/,
                  message: t("*Please Enter English Characters"),
                },
              }}
            />
          </div>

          <div className="input-div" key={allValue.child_surname}>
            <Controller
              key="othername"
              name="othername"
              control={control}
              defaultValue={allValue.child_surname}
              rules={{
                pattern: {
                  value: /^[a-zA-Z\s]*$/,
                  message: t("*Please Enter English Characters"),
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Kids Other Name")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
            />
          </div>
          <div className="input-div">
            <Controller
              key="gender"
              name="gender"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <div className="render-comp">
                  <FormControl
                    variant="standard"
                    sx={{ width: "100%" }}
                    error={!!error}
                  >
                    <InputLabel>{t("Gender")}</InputLabel>
                    <Select
                      {...field}
                      onChange={(event) => {
                        // console.log(event.target.value);
                        setValue("gender", event.target.value);
                        trigger("gender");
                      }}
                    >
                      {constant.genderList.map((item) => {
                        const str = t(item);
                        const key = _.uniqueId("menuitem_");
                        return (
                          <MenuItem key={key} value={str}>
                            {str}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    {error ? (
                      <FormHelperText>{error.message}</FormHelperText>
                    ) : null}
                  </FormControl>
                </div>
              )}
              rules={{ required: t("Required") }}
            />
          </div>

          <div className="input-div">
            <Controller
              key="date"
              name="date"
              control={control}
              defaultValue={new Date()}
              render={({ field, fieldState: { error } }) => (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label={t("Date of Birth")}
                    {...field}
                    onChange={(v) => {
                      // console.log(v);
                      setValue("date", v);
                    }}
                    renderInput={(params) => (
                      <TextField
                        sx={{ width: "100%", marginBottom: "12px" }}
                        variant="standard"
                        {...params}
                      />
                    )}
                  />
                </LocalizationProvider>
              )}
              rules={{ required: "required" }}
            />
          </div>
          <div className="input-div full-width">
            <h1 className="mb-1">{t("Fill in the Parent information")}</h1>
          </div>
          <div className="input-div">
            <Controller
              key="prefix"
              name="prefix"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <div className="render-comp">
                  <FormControl
                    variant="standard"
                    sx={{ width: "100%" }}
                    error={!!error}
                  >
                    <InputLabel>{t("Title")}</InputLabel>
                    <Select
                      {...field}
                      onChange={(event) => {
                        setValue("prefix", event.target.value);
                        trigger("prefix");
                      }}
                    >
                      {constant.prefixList.map((item) => {
                        const str = t(item);
                        const key = _.uniqueId("menuitem_");
                        return (
                          <MenuItem key={key} value={str}>
                            {str}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    {error ? (
                      <FormHelperText>{error.message}</FormHelperText>
                    ) : null}
                  </FormControl>
                </div>
              )}
            />
          </div>
          <div className="input-div">
            <Controller
              key="parentname"
              name="parentname"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Parent's Name")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              rules={{
                required: t("Required"),
                pattern: {
                  value: /^[a-zA-Z\s]*$/,
                  message: t("*Please Enter English Characters"),
                },
              }}
            />
          </div>

          <div className="input-div">
            <Controller
              key="email"
              name="email"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Email")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              rules={{
                required: t("Required"),
                pattern: {
                  value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                  message: t("Invalid email"),
                },
              }}
            />
          </div>
          <div className="input-div">
            <Controller
              key="confirmEmail"
              name="confirmEmail"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Confirm email")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              rules={{
                required: t("Required"),
                pattern: {
                  value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                  message: t("Invalid email"),
                },
                validate: {
                  isValid: (value) => isValidConfrimEmail(value),
                },
              }}
            />
          </div>

          <div className="input-div">
            <Controller
              key="emergencyname"
              name="emergencyname"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  sx={{ width: "100%" }}
                  label={t("Emergency Contact Name")}
                  variant="standard"
                  error={!!error}
                  helperText={error ? error.message : null}
                  {...field}
                />
              )}
              rules={{
                required: t("Required"),
                pattern: {
                  value: /^[a-zA-Z\s]*$/,
                  message: t("*Please Enter English Characters"),
                },
              }}
            />
          </div>

          <div className="input-div">
            <Controller
              key="emergencyContactPhoneNumber"
              name="emergencyContactPhoneNumber"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  type={"number"}
                  sx={{ width: "100%" }}
                  label={t("Emergency Contact Phone Number")}
                  variant="standard"
                  {...field}
                  error={!!error}
                  helperText={error ? error.message : null}
                />
              )}
              rules={{
                required: t("Required"),
                pattern: {
                  value: /^[0-9]*$/,
                  message: t("Invalid Phone no."),
                },
                minLength: {
                  value: 8,
                  message: t("Invalid Phone no."),
                },
              }}
            />
          </div>
          <div className="input-div">
            <Controller
              key="promo_code"
              name="promo_code"
              control={control}
              defaultValue=""
              render={({ field, fieldState: { error } }) => (
                <TextField
                  type={"text"}
                  sx={{ width: "100%" }}
                  label={t("Promo Code")}
                  variant="outlined"
                  {...field}
                  error={!!error}
                  helperText={error ? error.message : null}
                  onChange={(e) => {
                    setValue("promo_code", e.target.value.toLocaleUpperCase());
                  }}
                />
              )}
            />
          </div>
        </div>

        <h1 className="mb-2">{t("Receive Promotional Information")}</h1>
        <ol className={`${styles.orderlist} mb-8`}>
          <li>
            <div>{t("information provided")}</div>
          </li>
          <li>
            <div>{t("personal information")}</div>
          </li>
          <div className="checkbox">
            <Controller
              key="pi-0"
              name="pi-0"
              control={control}
              defaultValue={true}
              render={({ field, fieldState: { error } }) => (
                <FormControl component="fieldset" error={error}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          defaultChecked
                          style={{
                            color: "#FFA836", // Change this color to your desired color
                          }}
                        />
                      }
                      label={t("agree information")}
                    />
                    {error ? (
                      <FormHelperText sx={{ marginBottom: "16px" }}>
                        {error.message}
                      </FormHelperText>
                    ) : null}
                  </FormGroup>
                </FormControl>
              )}
            />

            <div style={{ fontSize: "11px" }}>
              <i>
                {t("dont want to receive")}
                <a href="mailto:cs@elite-paradise.tech">
                  {" "}
                  cs@elite-paradise.tech
                </a>
                。
              </i>
            </div>
          </div>
          <li>
            <div>{t("photoshoot")}</div>
          </li>
          <div className="checkbox">
            <Controller
              key="pi-1"
              name="pi-1"
              control={control}
              defaultValue={true}
              render={({ field, fieldState: { error } }) => (
                <FormControl component="fieldset" error={error}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          defaultChecked
                          style={{
                            color: "#FFA836", // Change this color to your desired color
                          }}
                        />
                      }
                      label={t("agree photoshoot")}
                    />
                    {error ? (
                      <FormHelperText>{error.message}</FormHelperText>
                    ) : null}
                  </FormGroup>
                </FormControl>
              )}
            />
          </div>
          <li>
            <div>
              {t("change information")}
              <a href="mailto:cs@elite-paradise.tech">
                {" "}
                cs@elite-paradise.tech
              </a>
              。
            </div>
          </li>
        </ol>
        {price && price > 0 ? (
          <>
            <h1 className="mb-5">{t("Select payment method")}</h1>
            <PaymentMethod xc="mb-2" paymentItmeProps={paymentItmeProps} />
          </>
        ) : null}
      </div>
    </div>
  );
};

export default InputCard;
